// Small utility to generate a lightweight SVG shimmer blurDataURL
export function shimmer(width = 16, height = 12) {
    return `
    <svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="g">
          <stop stop-color="#eee" offset="20%" />
          <stop stop-color="#ddd" offset="50%" />
          <stop stop-color="#eee" offset="70%" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="#eee" />
      <rect id="r" width="100%" height="100%" fill="url(#g)" />
      <animate xlink:href="#r" attributeName="x" from="-100%" to="100%" dur="1s" repeatCount="indefinite" />
    </svg>`;
}

export const toBase64 = (str) =>
    typeof window === 'undefined'
        ? Buffer.from(str).toString('base64')
        : window.btoa(str);

export function getBlurDataURL(width = 16, height = 12) {
    return `data:image/svg+xml;base64,${toBase64(shimmer(width, height))}`;
}
